import { Preferences } from '../../profile/objects/preferences';
import { Column } from '../../utils/list/objects/column';
import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';
import { CLIENT_AUTH_USERS_MODULE, DEFAULT_CLIENT_AUTH_USERS_COLUMNS } from '../constant/clientAuthConstant';

export const setClientAuthPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: CLIENT_AUTH_USERS_MODULE,
        default_columns: DEFAULT_CLIENT_AUTH_USERS_COLUMNS,
        default_order_by: '',
        default_order: 'asc',
    });
